import { render, staticRenderFns } from "./RestStatus.vue?vue&type=template&id=b82bb1fe&scoped=true&lang=pug&"
import script from "./RestStatus.vue?vue&type=script&lang=ts&"
export * from "./RestStatus.vue?vue&type=script&lang=ts&"
import style0 from "./RestStatus.vue?vue&type=style&index=0&id=b82bb1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82bb1fe",
  null
  
)

export default component.exports